"use strict";
import $ from "jquery";
export default {
  lookupById(id) {
    return new Promise((resolve, reject) => {
      $.get(`/api/tms/profit_centers/by_external_id?id=${id}`).then(
        (data) => data.address ? resolve(data) : reject(new Error("No matches found"))
      );
    });
  }
};
